export default "__VITE_ASSET__JBr5yIrb__"